<nz-card nzHoverable
         [nzCover]="coverTemplate"
         class="card-ccs-container"
         [nzActions]="hasActionButtons ? [actionsTemplate] : []"
         (click)="itemClicked()">
  <!-- [nzActions]="[zerothActionTemplate,firstActionTemplate, secondActionTemplate, thirdActionTemplate]" -->

  <!-- Top Right Icon -->
  <div *ngIf="topRightIcon"
       class="top-right-icon">
    <rappider-icon [name]="topRightIcon.name"
                   [theme]="topRightIcon.theme"
                   [type]="topRightIcon.type"
                   [color]="topRightIcon.color"
                   [size]="topRightIcon.size"></rappider-icon>
  </div>

  <div class="card-content-container">
    <ng-container *ngIf="colorBand">
      <div class="color-band"
           [style.background-color]="colorBand"></div>
    </ng-container>
    <div class="card-content">
      <div class="title-container"
           *ngIf="title">
        <ng-container *ngIf="getTitleIconConfig() as icon">
          <rappider-icon [name]="icon.name"
                         [type]="icon.type"
                         [theme]="icon.theme"
                         [color]="icon.color"
                         [size]="icon.size"
                         class="title-icon"></rappider-icon>
        </ng-container>
        <rappider-heading [content]="title.content"
                          [type]="title.type"></rappider-heading>
      </div>
      <div *ngIf="subtitles?.length"
           [class]="getTitleIconConfig() ? 'subtitle-icon-padding' : ''"
           (mousedown)="itemClicked()">
        <ng-container *ngFor="let subtitle of subtitles">
          <ng-container *ngIf="shouldShowJsonViewer(subtitle.content); else defaultRappiderText">
            <rappider-json-viewer [data]="getObjectFromContent(subtitle.content)"
                                  [maxLineToDisplay]="6"></rappider-json-viewer>
          </ng-container>
          <ng-template #defaultRappiderText>
            <rappider-text *ngIf="subtitle?.content && !shouldShowJsonViewer(subtitle.content)"
                           [content]="subtitle.content"
                           [textMode]="subtitle.textMode || 'html'"
                           [text]="subtitle.content"
                           [colorSettings]="subtitle.colorSettings"></rappider-text>

          </ng-template>
        </ng-container>
      </div>
      <ng-container *ngIf="description">
        <div class="description-container">
          <ng-container *ngIf="description.content && shouldShowJsonViewer(description.content); else defaultDescriptionText">
            <rappider-json-viewer [data]="getObjectFromContent(description.content)"
                                  [maxLineToDisplay]="6"></rappider-json-viewer>
          </ng-container>
          <ng-template #defaultDescriptionText>
            <rappider-text *ngIf="description.content && !shouldShowJsonViewer(description.content)"
                           [content]="description.content"
                           [textMode]="description.textMode"
                           [text]="description.text"
                           [typography]="description.typography"
                           [colorSettings]="description.colorSettings"></rappider-text>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="selected"
       class="selected-card-icon">
    <rappider-icon [name]="selectedCardIcon.name"
                   [theme]="selectedCardIcon.theme"
                   [type]="selectedCardIcon.type"
                   [color]="selectedCardIcon.color"></rappider-icon>
  </div>
</nz-card>

<ng-template #coverTemplate>
  <ng-container *ngIf="image">
    <rappider-image class="cover-img"
                    [source]="image?.source"
                    [width]="image?.width"
                    [height]="image?.height"
                    [placeholder]="image?.placeholder"
                    [alternateText]="image?.alternateText"
                    [fallback]="image?.fallback"
                    [disablePreview]="image?.disablePreview"
                    [borderSettings]="image?.borderSettings"
                    [shadowSettings]="image?.shadowSettings"
                    [marginSettings]="image?.marginSettings"
                    [paddingSettings]="image?.paddingSettings"
                    [customSizeSettings]="image?.customSizeSettings"></rappider-image>
  </ng-container>
  <ng-container *ngIf="!image && thumbnailTemplate">
    <ng-container *ngTemplateOutlet="thumbnailTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #firstActionTemplate>
  <ng-container *ngIf="firstActionButton">
    <rappider-button [tooltipText]="firstActionButton.tooltipText"
                     [transparent]="firstActionButton.transparent"
                     [colorType]="firstActionButton.colorType"
                     [shape]="firstActionButton.shape"
                     [type]="firstActionButton.type"
                     [text]="firstActionButton.text"
                     [size]="firstActionButton.size"
                     [icon]="firstActionButton.icon"
                     [loading]="firstActionButton.loading"
                     [block]="firstActionButton.block"
                     [disabled]="firstActionButton.disabled"
                     [icon]="firstActionButton.icon"
                     [emitWithoutPopconfirm]="firstActionButton.emitWithoutPopconfirm"
                     [popconfirmTitle]="firstActionButton.popconfirmTitle"
                     [tooltipText]="firstActionButton.tooltipText"
                     (confirm)="actionClicked(firstActionButton)"
                     (click)="$event?.stopPropagation()"></rappider-button>
  </ng-container>
</ng-template>
<ng-template #secondActionTemplate>
  <ng-container *ngIf="secondActionButton">
    <rappider-button [transparent]="secondActionButton.transparent"
                     [colorType]="secondActionButton.colorType"
                     [shape]="secondActionButton.shape"
                     [type]="secondActionButton.type"
                     [text]="secondActionButton.text"
                     [size]="secondActionButton.size"
                     [icon]="secondActionButton.icon"
                     [loading]="secondActionButton.loading"
                     [block]="secondActionButton.block"
                     [disabled]="secondActionButton.disabled"
                     [icon]="secondActionButton.icon"
                     [emitWithoutPopconfirm]="secondActionButton.emitWithoutPopconfirm"
                     [popconfirmTitle]="secondActionButton.popconfirmTitle"
                     [tooltipText]="secondActionButton.tooltipText"
                     (confirm)="actionClicked(secondActionButton)"
                     (click)="$event?.stopPropagation()"></rappider-button>
  </ng-container>
</ng-template>
<ng-template #thirdActionTemplate>
  <ng-container *ngIf="thirdActionButton">
    <rappider-button [transparent]="thirdActionButton.transparent"
                     [colorType]="thirdActionButton.colorType"
                     [shape]="thirdActionButton.shape"
                     [type]="thirdActionButton.type"
                     [text]="thirdActionButton.text"
                     [size]="thirdActionButton.size"
                     [icon]="thirdActionButton.icon"
                     [loading]="thirdActionButton.loading"
                     [block]="thirdActionButton.block"
                     [disabled]="thirdActionButton.disabled"
                     [icon]="thirdActionButton.icon"
                     [emitWithoutPopconfirm]="thirdActionButton.emitWithoutPopconfirm"
                     [popconfirmTitle]="thirdActionButton.popconfirmTitle"
                     [popconfirmOkText]="thirdActionButton.popconfirmOkText"
                     [popconfirmOkDanger]="thirdActionButton.popconfirmOkDanger"
                     [tooltipText]="thirdActionButton.tooltipText"
                     (confirm)="actionClicked(thirdActionButton)"
                     (click)="$event?.stopPropagation()"></rappider-button>
  </ng-container>
</ng-template>
<ng-template #actionsTemplate>
  <div class="card-actions-container">
    <ng-container *ngIf="zerothActionButton">
      <rappider-button [transparent]="zerothActionButton.transparent"
                       [colorType]="zerothActionButton.colorType"
                       [shape]="zerothActionButton.shape"
                       [type]="zerothActionButton.type"
                       [text]="zerothActionButton.text"
                       [size]="zerothActionButton.size"
                       [icon]="zerothActionButton.icon"
                       [loading]="zerothActionButton.loading"
                       [block]="zerothActionButton.block"
                       [disabled]="zerothActionButton.disabled"
                       [icon]="zerothActionButton.icon"
                       [emitWithoutPopconfirm]="zerothActionButton.emitWithoutPopconfirm"
                       [popconfirmTitle]="zerothActionButton.popconfirmTitle"
                       [popconfirmOkText]="zerothActionButton.popconfirmOkText"
                       [popconfirmOkDanger]="zerothActionButton.popconfirmOkDanger"
                       [tooltipText]="zerothActionButton.tooltipText"
                       (confirm)="actionClicked(zerothActionButton)"
                       (click)="$event?.stopPropagation()"></rappider-button>
    </ng-container>
    <ng-container *ngIf="firstActionButton">
      <rappider-button [tooltipText]="firstActionButton.tooltipText"
                       [transparent]="firstActionButton.transparent"
                       [colorType]="firstActionButton.colorType"
                       [shape]="firstActionButton.shape"
                       [type]="firstActionButton.type"
                       [text]="firstActionButton.text"
                       [size]="firstActionButton.size"
                       [icon]="firstActionButton.icon"
                       [loading]="firstActionButton.loading"
                       [block]="firstActionButton.block"
                       [disabled]="firstActionButton.disabled"
                       [icon]="firstActionButton.icon"
                       [emitWithoutPopconfirm]="firstActionButton.emitWithoutPopconfirm"
                       [popconfirmTitle]="firstActionButton.popconfirmTitle"
                       [tooltipText]="firstActionButton.tooltipText"
                       (confirm)="actionClicked(firstActionButton)"
                       (click)="$event?.stopPropagation()"></rappider-button>
    </ng-container>
    <ng-container *ngIf="secondActionButton">
      <rappider-button [transparent]="secondActionButton.transparent"
                       [colorType]="secondActionButton.colorType"
                       [shape]="secondActionButton.shape"
                       [type]="secondActionButton.type"
                       [text]="secondActionButton.text"
                       [size]="secondActionButton.size"
                       [icon]="secondActionButton.icon"
                       [loading]="secondActionButton.loading"
                       [block]="secondActionButton.block"
                       [disabled]="secondActionButton.disabled"
                       [icon]="secondActionButton.icon"
                       [emitWithoutPopconfirm]="secondActionButton.emitWithoutPopconfirm"
                       [popconfirmTitle]="secondActionButton.popconfirmTitle"
                       [tooltipText]="secondActionButton.tooltipText"
                       (confirm)="actionClicked(secondActionButton)"
                       (click)="$event?.stopPropagation()"></rappider-button>
    </ng-container>
    <ng-container *ngIf="thirdActionButton">
      <rappider-button [transparent]="thirdActionButton.transparent"
                       [colorType]="thirdActionButton.colorType"
                       [shape]="thirdActionButton.shape"
                       [type]="thirdActionButton.type"
                       [text]="thirdActionButton.text"
                       [size]="thirdActionButton.size"
                       [icon]="thirdActionButton.icon"
                       [loading]="thirdActionButton.loading"
                       [block]="thirdActionButton.block"
                       [disabled]="thirdActionButton.disabled"
                       [icon]="thirdActionButton.icon"
                       [emitWithoutPopconfirm]="thirdActionButton.emitWithoutPopconfirm"
                       [popconfirmTitle]="thirdActionButton.popconfirmTitle"
                       [popconfirmOkText]="thirdActionButton.popconfirmOkText"
                       [popconfirmOkDanger]="thirdActionButton.popconfirmOkDanger"
                       [tooltipText]="thirdActionButton.tooltipText"
                       (confirm)="actionClicked(thirdActionButton)"
                       (click)="$event?.stopPropagation()"></rappider-button>
    </ng-container>
  </div>
</ng-template>
